import { gql } from "@apollo/client";
import { apolloClient } from "../apolloClient";

export default async function sendNotification(_: any, params: any) {
  const result = await apolloClient.mutate({
    mutation: gql`
      mutation sendNotification($notificacion: SendNotificacionInput!) {
        sendNotificacion(createNotificacionesInput: $notificacion) {
          id
          status
          recipientCount
          submittedCount
          deliveredCount
          failedCount
          invalidTokenCount
        }
      }
    `,
    variables: {
      notificacion: {
        idempotencyKey: params.data.idempotencyKey,
        clinicas: params.data.Clinicas,
        franquicias: params.data.Franquicias,
        users: params.data.Usuarios,
        payload: {
          body: params.data.body,
          imageUrl: params.data.imagen,
          title: params.data.titulo,
          url: params.data.url,
          details: params.data.details,
        },
      } as SendNotificacionInput,
    },
  });
  if (!result.data?.sendNotificacion) {
    throw new Error("No se ha podido completar la operacion");
  }
  return {
    data: {
      ...params.data,
      ...result.data.sendNotificacion,
      id: result.data.sendNotificacion.id,
    },
  };
}

type SendNotificacionInput = {
  idempotencyKey: string;
  payload: Payload;
  users?: string[];
  clinicas?: string[];
  franquicias?: string[];
};

type Payload = {
  title: string;
  body: string;
  url?: string;
  imageUrl?: string;
  details?: string;
};
